module.exports = __webpack_public_path__ + "static/img/wg_footer_btn.5b400c7e.png";